import { WidgetType } from '@enums/WidgetType'

export const WIDGET_LOGO_ALT = {
  TRAFFIC_SIGNAL_ALT: 'Traffic Signal logo',
  FASTAG_LOGO_ALT: 'FASTag logo',
  PUC_LOGO_ALT: 'PUC logo',
  LOCK_ICON: 'Lock icon'
}

const CAMPAIGN_NAME = {
  [WidgetType.PUC_WIDGET]: 'SEO_Puc',
}

enum SOURCE_NAME {
  SEO = 'SEO',
  SEM = 'SEM',
}

export const APP_FLYER_DEFAULT_PAYLOAD = {
  is_app_only: true,
  campaign_name: CAMPAIGN_NAME.pucWidget,
  source: SOURCE_NAME.SEO,
}

export const CLOSE_BTN_ALT = 'close btn'

export const CLOSE_BTN_ICON = '/images/icons/close.png'

export const INPUT_ERROR = 'Enter Car or Bike number'
export const INPUT_ERROR_NOT_VALID = 'Enter a valid registration number'

export const SCANNER_TEXT = 'to unlock complete vehile information,'
export const APP_DOWNLOAD_PROMPT = 'download the ACKO app'

export const DOWNLOAD_APP = 'Download Now'

export const SCANNER_ALT = 'Scanner img'

export const EVENT_ERROR = 'Error tracking event'

export const PUC_API_ERROR = 'Error fetching PUC data'

export const PUC_WIDGET = 'pucWidget'

export const RTO_VEHICLE_INFO_WIDGET = 'rtoVehicleInfo'

export const RTO_DETAIL_WIDGET = 'rtoDetail'

export const CHALLAN_WIDGET = 'challanWidget'

export enum PUC_DETAIL {
  isActive = 'Active',
  isExpired = 'Expired',
  isExpires = 'Expires',
}

export const WIDGET_CTA_FALLBACK_PUC = 'Check PUC'
export const WIDGET_CTA_FALLBACK_VEHICLE_INFO = 'Check vehicle info'
export const INPUT_PLACEHOLDER = 'AB 12 CD 3456'

export const PUC_HEADING = 'Pollution certificate is '

export const SCAN_TO_DOWNLOAD = 'scan to download'

export const VEHICLE_BANNER_ALT = 'car icon'

export const AUTO_HEADER_KEY = 'x-app-name'
export const AUTO_HEADER_VALUE = 'carbon'

export const KEY_FEATURES = {
  keyDefaultOne: 'Traffic challans',
  keyDefaultTwo: 'Low FASTag Balance',
  keyDefaultThree: 'PUC Expiry',
  keyDefaultHeading: 'Get real-time vehicle alerts on the ACKO app',
  keyDefaultSubHeading: 'download the ACKO app',
}

export const BASE_URL = 'https://www.acko.com/'

export const PUC_WIDGET_DESCRIPTION = 'We ll get to know about your vehicle PUC details from all RTOs'
export const RTO_DETAIL_DESCRIPTION = "We'll get to know about your vehicle details from the registered RTO"
export const CHALLAN_WIDGET_DESCRIPTION = "We'll get to know about your vehicle challans from the RTO"

export const DEEP_LINK_DEFAULT = 'https://tinyurl.internal.live.acko.com/api/v1/appflyer_deep_link/'

export const PUC_LOGIN_TEXT = 'GET PUC details'

export const FETCH_URL = '/api/app/'
export const DASH_FALLBACK = '-'

export const AUTO_DATA_FALLBACK = { db_make_name: '', db_model_name: '' }

export const WIDGET_STATUS_FALLBACK = {
  IS_PUC_WIDGET: false,
  IS_PUC_STATUS: false,
  IS_CHALLAN_WIDGET: false,
  CHALLAN_AMOUNT: 0,
}
